/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

const clientId = process.env.REACT_APP_ENTRAID_CLIENT_ID!;
const authority = process.env.REACT_APP_ENTRAID_AUTHORITY!;
const redirectURI = process.env.REACT_APP_ENTRAID_REDIRECT_URI!;
const postLogoutRedirectURI = process.env.REACT_APP_ENTRAID_POST_LOGOUT_REDIRECT_URI!;

export const msalConfig = {
    // auth: {
    //     clientId: 'Enter_the_Application_Id_Here', // This is the ONLY mandatory field that you need to supply.
    //     authority: 'https://kolula.ciamlogin.com/', // Replace the placeholder with your tenant subdomain 
    //     redirectUri: '/', // Points to window.location.origin.
    //     You must register this URI on Azure Portal/App Registration.
    //     postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    //     navigateToLoginRequestUrl: false, // If "true", will navigate back to the
    //     original request location before processing the auth code response.
    // },
    auth: {
        clientId: clientId,
        authority: authority,
        redirectUri: redirectURI,
        postLogoutRedirectUri: postLogoutRedirectURI,
    },
    cache: {
        // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        cacheLocation: 'sessionStorage',
        // Set this to "true" if you are having issues on IE11 or Edge
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        // eslint-disable-next-line no-console
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        // eslint-disable-next-line no-console
                        return;
                    case LogLevel.Verbose:
                        // eslint-disable-next-line no-console
                        return;
                    case LogLevel.Warning:
                        // eslint-disable-next-line no-console
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [],
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
// export const silentRequest = {
//     scopes: ["openid", "profile"],
//     loginHint: "example@domain.net"
// };
